import React from 'react';
import { HeaderTemplate, KeyValue, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import AccessMatrixWindowPeriod from '../../../components/cards/AccessMatrixWindowPeriod';

interface NonExamNotAvailableProps {
  errorMessage: string;
  examTitle: string;
  examTypeDisplay: string;
}

const NonExamNotAvailable = ({
  errorMessage,
  examTitle,
  examTypeDisplay,
}: NonExamNotAvailableProps) => {
  const { t } = useTranslation();
  const link = '/';
  const label = t('exam->>ResultListing.Back to Homepage');

  return (
    <>
      <TitleHeader title={examTitle} />
      {examTypeDisplay && (
        <HeaderTemplate>
          <KeyValue
            keyText={t('exam->>RegisterExamInstructions.Exam Level')}
            valueText={examTypeDisplay}
          />
        </HeaderTemplate>
      )}

      <AccessMatrixWindowPeriod contentBody={errorMessage} buttonLink={link} buttonLabel={label} />
    </>
  );
};

export default NonExamNotAvailable;
